exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-table-link,.action-table-recipient-link{color:#4eb0b9;text-decoration:none;cursor:pointer}.action-table-link:hover,.action-table-recipient-link:hover{text-decoration:underline}.action-table-recipient-link{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px}.action-table-icon{width:1em;height:1em;vertical-align:-0.15em;fill:currentColor;overflow:hidden}.action-table-grid{height:600px;width:100%}.action-table-grid .ag-row{cursor:pointer}", ""]);

// exports
